<div class="password-set-container">
    <form [formGroup]="passwordForm">
      
      <!-- Password Field -->
      <span class="label-with-link">
        <label class="label" for="input-password">{{ 'auth.passwordSet.passwordLabel' | translate }}</label>
      </span>
  
      <input nbInput
             fullWidth
             formControlName="password"
             [showStatusIconOn]="{ showOnControlStatus: ['valid','invalid'] }"
             type="password"
             id="input-password"
             [placeholder]="'auth.passwordSet.passwordLabel' | translate"
             fieldSize="large"
             [status]="passwordCtrl.dirty ? (passwordCtrl.invalid ? 'danger' : 'success') : 'basic'"
             [required]="true"
             [attr.aria-invalid]="passwordCtrl.invalid && passwordCtrl.touched ? true : null">
  
      <!-- Password Repeat Field -->
      <span class="label-with-link">
        <label class="label" for="input-password-repeat">{{ 'auth.passwordSet.repeatPasswordLabel' | translate }}</label>
      </span>
  
      <input nbInput
             fullWidth
             formControlName="passwordRepeat"
             [showStatusIconOn]="{ showOnControlStatus: ['valid','invalid'], invalidOnParentErrors: ['passwordRepeatMatchValidator'] }"
             type="password"
             id="input-password-repeat"
             [placeholder]="'auth.passwordSet.repeatPasswordLabel' | translate"
             fieldSize="large"
             [status]="passwordRepeatCtrl.dirty ? (passwordRepeatCtrl.invalid || !passwordsMatch ? 'danger' : 'success') : 'basic'"
             [required]="true"
             [attr.aria-invalid]="passwordRepeatCtrl.invalid && passwordRepeatCtrl.touched ? true : null">
  
      <!-- Passwords don't match error -->
      <ng-container *ngIf="passwordCtrl.touched && passwordRepeatCtrl.touched && !passwordsMatch">
        <p class="caption status-danger">
          {{ 'auth.passwordSet.mismatchError' | translate }}
        </p>
      </ng-container>
  
      <!-- Password Requirements Checklist -->
      <app-password-criteria
        [expanded]="passwordCtrl.dirty"
        [details]="passwordCtrl.errors?.details">
      </app-password-criteria>
  
      <!-- Submit Button (optional) -->
      <button *ngIf="showSubmitButton"
              nbButton
              fullWidth
              status="primary"
              size="large"
              [disabled]="!isValid || disabled"
              (click)="submit()">
        {{ submitButtonText }}
      </button>
  
    </form>
  </div>